'use client';

import { useEffect, useRef, type ReactNode } from 'react';

export default function OwlSticker({ children }: { children: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!window.matchMedia('(pointer: fine) and (prefers-reduced-motion: no-preference)').matches) return;
    let frame = 0;
    let x = 0;
    let y = 0;
    const move = (event: MouseEvent) => {
      x = (event.clientX / window.innerWidth - 0.5) * 2;
      y = (event.clientY / window.innerHeight - 0.5) * 2;
      if (frame) return;
      frame = requestAnimationFrame(() => {
        if (ref.current) ref.current.style.transform = `rotate(${6 + x * 3}deg) translate(${x * 6}px, ${y * 6}px)`;
        frame = 0;
      });
    };
    window.addEventListener('mousemove', move, { passive: true });
    return () => { window.removeEventListener('mousemove', move); cancelAnimationFrame(frame); };
  }, []);
  return <div ref={ref} className="ph-sticker" style={{ transform: 'rotate(6deg)', transition: 'transform 0.3s ease-out' }}>{children}</div>;
}
